/* global updateCartTieredIncentiveProgress */
(function freeGift() {
  const config = window.freeGiftConfig || {};
  const GIFT_VARIANT_ID = Number(config.variantId);
  const THRESHOLD_CENTS = Number(config.thresholdCents) || 15000;
  const GIFT_PROPERTY = config.propertyKey || '_labor_day_gift';
  const START = config.startDate ? new Date(config.startDate) : null;
  const END = config.endDate ? new Date(config.endDate) : null;

  if (!Number.isFinite(GIFT_VARIANT_ID) || GIFT_VARIANT_ID <= 0) {
    console.warn('Free gift: no valid variant ID configured.');
    return;
  }

  if (config.isWholesale === true) return;

  let syncChain = Promise.resolve();
  let syncTimer;

  const isActive = () => {
    const now = new Date();
    if (START && Number.isFinite(START.getTime()) && now < START) return false;
    if (END && Number.isFinite(END.getTime()) && now > END) return false;
    return true;
  };

  const isGiftLine = (item) => Boolean(item.properties && item.properties[GIFT_PROPERTY]);

  const eligibleSubtotal = (cart) => cart.items.reduce(
    (sum, item) => (isGiftLine(item) ? sum : sum + item.final_line_price),
    0
  );

  async function postJson(url, body) {
    const res = await fetch(url, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
    if (!res.ok) {
      const detail = await res.text();
      throw new Error(`${url} failed: ${res.status} ${detail}`);
    }
    return res.json();
  }

  async function addGift() {
    return postJson('/cart/add.js', {
      items: [{
        id: GIFT_VARIANT_ID,
        quantity: 1,
        properties: { [GIFT_PROPERTY]: 'true' }
      }]
    });
  }

  async function setGiftQuantity(key, quantity) {
    return postJson('/cart/change.js', { id: key, quantity });
  }

  function syncFreeGift(cartData) {
    syncChain = syncChain
      .then(() => runSync(cartData))
      .catch((err) => { console.error('Free gift sync error:', err); });
    return syncChain;
  }

  async function runSync(cartData) {
    {
      let cart = cartData;
      if (!cart || !Array.isArray(cart.items)) {
        const res = await fetch('/cart.js', { credentials: 'same-origin' });
        if (!res.ok) throw new Error(`Cart request failed: ${res.status}`);
        cart = await res.json();
      }

      const wrap = document.querySelector('[data-cart-incentives]');
      if (wrap) wrap.dataset.giftPromoActive = isActive() ? 'true' : 'false';

      const giftLines = cart.items.filter(isGiftLine);
      const qualifies = isActive()
        && cart.items.some((item) => !isGiftLine(item))
        && eligibleSubtotal(cart) >= THRESHOLD_CENTS;

      let changed = false;

      if (qualifies) {
        if (giftLines.length === 0) {
          await addGift();
          changed = true;
        } else {
          for (let i = 1; i < giftLines.length; i += 1) {
            await setGiftQuantity(giftLines[i].key, 0);
            changed = true;
          }
          if (giftLines[0].quantity !== 1) {
            await setGiftQuantity(giftLines[0].key, 1);
            changed = true;
          }
        }
      } else if (giftLines.length) {
        for (const line of giftLines) {
          await setGiftQuantity(line.key, 0);
          changed = true;
        }
      }

      if (changed) {
        document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh'));
        if (typeof updateCartTieredIncentiveProgress === 'function') {
          setTimeout(() => updateCartTieredIncentiveProgress(), 150);
        }
      }
    }
  }

  const CART_EVENTS = [
    'on:cart:add',
    'on:line-item:change',
    'cart:change',
    'cart:updated',
    'cart:refresh',
    'cart:requestComplete',
    'ajaxify:cart:updated'
  ];

  const queueSync = () => {
    window.clearTimeout(syncTimer);
    syncTimer = window.setTimeout(() => syncFreeGift(), 250);
  };

  CART_EVENTS.forEach((evt) => {
    document.addEventListener(evt, () => queueSync());
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => syncFreeGift());
  } else {
    syncFreeGift();
  }

  window.syncFreeGift = syncFreeGift;
}());